import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Connects to data-controller="resumin--bridge--in-app-review"
// このコンポーネントは、HotwireNativeで実装したアプリのみ動作します。
// 履歴書/職務経歴書ダウンロード後、全モーダルが閉じたタイミングで
// アプリにストアレビュー表示をリクエストします。
export default class extends BridgeComponent {
  static component = "in-app-review";

  connect() {
    super.connect();
    this.canRequestReview = false;
  }

  enableReviewRequest() {
    this.canRequestReview = true;
  }

  requestNativeReview() {
    if (!this.canRequestReview) {
      return;
    }

    this.send("request-store-review", {}, () => {});
    this.canRequestReview = false;
  }
}
